import { Link } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { formatPrice, intervalLabel, planFeatures } from "../../lib/plans";

export default function PlanCard({ plan, onPurchase, busy, disabled }) {
  const features = planFeatures(plan.limits);
  return (
    <div
      data-testid="master-plan-card"
      className="flex h-full flex-col rounded-xl border border-[#E6E9F1] bg-white p-6 mb-card-shadow transition-all duration-300 hover:-translate-y-1 hover:border-[#FF6B00]/40"
    >
      <h3 className="text-lg font-bold text-slate-900">{plan.name}</h3>
      {plan.description && <p className="mt-1 text-sm text-slate-600 line-clamp-3">{plan.description}</p>}
      <div className="mt-5 flex items-baseline gap-1">
        {plan.isFree ? (
          <span className="text-3xl font-extrabold text-slate-900">Free</span>
        ) : (
          <>
            <span className="text-3xl font-extrabold text-slate-900">{formatPrice(plan.price)}</span>
            <span className="text-sm text-slate-500">/ {intervalLabel(plan.billingInterval)}</span>
          </>
        )}
      </div>
      <ul className="mt-5 flex-1 space-y-2">
        {features.map((f) => (
          <li key={f} className="flex items-start gap-2 text-sm text-slate-700">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#FF6B00]" />
            {f}
          </li>
        ))}
      </ul>
      <div className="mt-6 space-y-2">
        <Button
          onClick={() => onPurchase(plan)}
          disabled={disabled}
          className="w-full bg-[#FF6B00] text-white hover:bg-[#e55f00]"
          data-testid="master-plan-purchase"
        >
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Choose Plan
        </Button>
        <Link
          to={`/plans/${plan.id}`}
          className="block text-center text-sm font-medium text-slate-500 hover:text-[#FF6B00]"
        >
          View details
        </Link>
      </div>
    </div>
  );
}
